import { evalRunPath, type PartialEvalRun } from "~/services/evals";
import { ConfirmDeleteDialog } from "./ConfirmDeleteDialog";
import { formatEvalTimestamp } from "./primitives/format";
import { parseApiTimestamp } from "./selectors/core";

interface DeleteRunDialogProps {
  /** The run to delete. Null closes the dialog without a request. */
  run: Pick<PartialEvalRun, "id" | "started_at" | "tags"> | null;
  onOpenChange: (open: boolean) => void;
  onDeleted: () => void;
}

/**
 * The one confirmation for deleting a run, shared by the drawer's footer and the
 * runs table's row menu so both say the same thing about what is lost.
 */
export const DeleteRunDialog = ({ run, onOpenChange, onDeleted }: DeleteRunDialogProps) => (
  <ConfirmDeleteDialog
    open={run != null}
    onOpenChange={onOpenChange}
    title="Delete this run?"
    description={
      <>
        The run and every result it recorded are removed. The cases themselves are untouched.
        {run && (
          <span className="mt-2 block text-foreground">
            Started {formatEvalTimestamp(parseApiTimestamp(run.started_at))}
            {run.tags.length > 0 && ` · ${run.tags.join(", ")}`}
          </span>
        )}
      </>
    }
    confirmLabel="Delete run"
    path={run ? evalRunPath(run.id) : null}
    errorMessage="Could not delete the run."
    onDeleted={onDeleted}
  />
);
